import React from 'react';
export function ConversationIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5a3 3 0 013-3h9a3 3 0 013 3v6a3 3 0 01-3 3v2a1 1 0 01-1 1h-2a1 1 0 01-.832-.445L13.465 14H10a3 3 0 01-3-3V5zm3-1a1 1 0 00-1 1v6a1 1 0 001 1h4a1 1 0 01.832.445L16.535 15H17v-2a1 1 0 011-1h1a1 1 0 001-1V5a1 1 0 00-1-1h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8a1 1 0 00-1-1 3 3 0 00-3 3v6a3 3 0 003 3v2a1 1 0 001 1h2a1 1 0 00.832-.445L10.535 19H14a1 1 0 100-2h-4a1 1 0 00-.832.445L7.465 20H7v-2a1 1 0 00-1-1H5a1 1 0 01-1-1v-6a1 1 0 011-1 1 1 0 001-1z"
  }));
}